define('giftcertificatevariableamount_hide_price_view.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('giftcertificatevariableamount_hide_price_view', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return " ";
},"useData":true}, 'extensions/SC/GiftCertificateEnhancementExtension/1.1.2/', 'extensions/SC/GiftCertificateEnhancementExtension/1.1.2/', Handlebars);
});